import { Injectable } from '@angular/core';
import { HttpInterceptor,HttpClient, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { NativeStorage } from '@ionic-native/native-storage/ngx';
import { Plugins } from '@capacitor/core';
import { BaseUrl } from './service/Configuration';
import { Router } from '@angular/router';
import { ToolsProvider } from './provider/tools/tools';
import { MenuController } from '@ionic/angular';

const { Storage } = Plugins;

@Injectable({
  providedIn: 'root'
})
export class AuthInterceptorService implements HttpInterceptor {
  constructor(
    private _Storage: NativeStorage,
    private httpClient: HttpClient,
    private router: Router,
    public menu: MenuController,
    private tool: ToolsProvider) { }
  async saveStorage(key, value): Promise<void> {
    await Storage.set({ key: key, value: JSON.stringify(value) });

  }
   intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    
    let token: string = (localStorage.getItem('_cap_Token')!= null)? localStorage.getItem('_cap_Token').slice(1, -1):"login";
    
    let request = req;

    if (token != "login") {
      request = req.clone({
        setHeaders: {
          authorization: `Bearer ${ token }`
        }
      });
    }
   
    return next.handle(request).pipe(
      catchError((err: HttpErrorResponse) => {
        if (err.status === 401) {
        {
          this.salir();
        }
        }
        return throwError( err );
      })
    );
  } 

 /* async refreshToken()
  {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({
      "usuario": "dRodriguez",
      "refreshToken": localStorage.getItem('_cap_refreshToken').slice(1, -1)
    });

    await fetch("http://localhost:63660/api/refreshToken/refresh", {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    })
    .then( response => response.json())
    .then(result => {
      this.saveStorage('Token', result.Token.split("|")[0]).then(response => {
        this.saveStorage('refreshToken', result.Token.split("|")[1]).then(respons => {
          
        });
      });
    }).catch(error => console.log('error', error));
  }*/


  salir(){
    this.preventBack();
    setTimeout('preventBack()', 0);
    // tslint:disable-next-line:only-arrow-functions
    window.onunload = function() { location.reload(); };
    this.Logout();
    this.tool.saveStorage('UsuarioDH', null);
    this.tool.saveStorage('isAdmin', null);
    this.tool.RemoveStorage('Token');
    this.tool.RemoveStorage('refreshToken');
    this.menu.enable(false);
  }

  Logout(){
    this.router.navigate(['/login']);
    location.reload();
    this.preventBack();
    setTimeout('preventBack()', 0);
    window.onunload = function() { location.reload(); this.menu.enanle(true); };
  }

  preventBack() { window.history.forward(); this.menu.enable(false); }
}